var map = {
	"./Kambi/SearchMobileMenuSection.js": [
		98486,
		[
			8171
		]
	],
	"./Spectate/SearchMobileMenuSection.js": [
		5115,
		[
			4234
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17034;
module.exports = webpackAsyncContext;